import { render, staticRenderFns } from "./product-select-view.vue?vue&type=template&id=6d937ec2&scoped=true&"
import script from "./select-view.js?vue&type=script&lang=js&"
export * from "./select-view.js?vue&type=script&lang=js&"
import style0 from "./product-select-view.vue?vue&type=style&index=0&id=6d937ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d937ec2",
  null
  
)

export default component.exports